export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10219.76ddb3e9.jpg";